import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIndentIncrease = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M21 6H11" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 12H11" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 18H11" }),
		/* @__PURE__ */ _jsx("path", { d: "m3 8 4 4-4 4" })
	]
});
export default SvgIndentIncrease;
